import React, { useEffect, useState } from 'react';
import { DashboardLayout } from '../components/layout';
import { useAdminNavigation } from '../hooks/useAdminNavigation';
import { ArrowUp, Info } from 'lucide-react';
import styles from './DocumentsActivityPage.module.css';

interface ActivityItem {
  id: string;
  type: 'upload' | 'edit' | 'delete' | 'download' | 'access';
  documentName: string;
  adminName: string;
  timestamp: string;
}

const DocumentsActivityPage: React.FC = () => {
  const { sidebarCollapsed, setSidebarCollapsed, activeSection, setSelectedRegulation, handleNavClick, handleLogout } = useAdminNavigation();
  const [activities, setActivities] = useState<ActivityItem[]>([]);

  useEffect(() => {
    const raw = window.localStorage.getItem('document_activities');
    if (raw) {
      try {
        const parsed = JSON.parse(raw) as ActivityItem[];
        setActivities(parsed.map(a => ({ ...a })));
      } catch (err) {
        // ignore parse errors
        // eslint-disable-next-line no-console
        console.error('Failed to parse document_activities from localStorage', err);
      }
    }
  }, []);

  return (
    <DashboardLayout
      collapsed={sidebarCollapsed}
      activeSection={activeSection}
      welcomeLabel={'Document activity'}
      selectedRegulation={null}
      onToggleSidebar={() => setSidebarCollapsed(prev => !prev)}
      onNavClick={handleNavClick}
      onProfileClick={() => handleNavClick('profile')}
      onLogout={handleLogout}
      onRegulationModalClose={() => setSelectedRegulation(null)}
    >
      <section className={styles.activitySection}>
        <div className={styles.activityHeader}>
          <h2 className={styles.activityTitle}>All document activity</h2>
          <p className={styles.activitySubtitle}>All uploads, edits and deletions recorded in this workspace</p>
        </div>

        <div>
          {activities.length === 0 ? (
            <div className={styles.noActivity}>No activity recorded</div>
          ) : (
            <div className={styles.activityList}>
              {activities.map(act => {
                const ts = new Date(act.timestamp);
                const time = ts.toLocaleString();
                const iconClass = act.type === 'upload' ? 'upload' : act.type === 'edit' ? 'edit' : act.type === 'delete' ? 'delete' : 'upload';
                const icon = act.type === 'upload' ? <ArrowUp size={16} aria-hidden /> : act.type === 'edit' ? '✎' : act.type === 'delete' ? '✕' : <Info size={16} aria-hidden />;
                return (
                  <div key={act.id} className={styles.activityItem}>
                    <div className={`${styles.activityIcon} ${styles[iconClass]}`} aria-hidden>{icon}</div>
                    <div className={styles.activityBody}>
                      <div className={styles.activityName}>{act.documentName}</div>
                      <div className={styles.activityMeta}>{act.type} by <strong>{act.adminName}</strong></div>
                    </div>
                    <div className={styles.activityTime}>{time}</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </DashboardLayout>
  );
};

export default DocumentsActivityPage;
